import { Component, Vue } from 'vue-property-decorator'
import HighFilter from '@/components/highFilter/index.vue'
import { queryDirectordetail } from '@/api'
@Component({ name: 'TeamList', components: { HighFilter } })
export default class TeamList extends Vue {
  private list: any = []
  private list1: any = []
  private list2: any = []
  private list3: any = []

  created () {
    this.initData()
  }

  private async initData () {
    const result: any = await queryDirectordetail({ id: this.$route.query.id })
    this.list = result.haventClass
    this.list1 = result.inClass
    this.list2 = result.isEndClass
    this.list3 = result.willEndClass
  }
}
